import styles from './AppDownloadArticle.module.scss';

import React, { useMemo, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { AppleAppStoreLink } from './AppleAppStoreLink';
import { GooglePlayStoreLink } from './GooglePlayStoreLink';
import { AppQrCode } from './AppQrCode';
import { stringifyUrl } from 'query-string';
import { getHeapUserId } from 'util/Analytics';

export const AppDownloadArticle: React.FC<HTMLAttributes<HTMLElement>> = ({ children, className, ...props }) => {
  const { t } = useTranslation();

  const heapUserId = getHeapUserId();

  const url = useMemo(() => stringifyUrl({
    url: `${window.location.origin}/online-ordering/app`,
    query: { heapUserId },
  }), [heapUserId]);

  return (
    <article className={clsx(styles.article, className)} {...props}>
      <header>
        <h2>{t('appDownload.heading')}</h2>
        <span>{t('appDownload.subheading')}</span>
      </header>

      <section>
        <figure>
          <figcaption>{t('appDownload.scan')}</figcaption>
          <AppQrCode width={200} height={200} />
        </figure>

        {children}
      </section>

      <footer>
        <GooglePlayStoreLink url={url} />
        <AppleAppStoreLink />
      </footer>
    </article>
  );
};
